<template>
  <div class="relativeclass">
    <label class="newInt-sc-font"
      >{{ label }}<span v-if="mandatory" class="asterik">*</span></label
    >
    <div
      class="w-100 d-flex align-items-center justify-content-center"
      :class="
        fileExtension === 'pdf'
          ? 'upload-pdf-file-name mt-2 mb-4'
          : ($route.name == 'Kanban' || $route.name == 'VendorKanban') &&
            isFileUploaded
          ? 'img-scroll'
          : ''
      "
    >
      <div
        v-if="!isFileUploaded"
        class="my-3 newUploadDoc relativeclass"
        v-b-tooltip.hover.html.bottom
        :title="tooltipContent"
        :class="{
          validationinputfile: showError || maxSize || invalidFile,
          'box-size-docs': id === 'feedback',
        }"
      >
        <b-form-file
          :accept="acceptedFormat.join(',')"
          ref="uploadFiles"
          :id="id"
          :type="type"
          :placeholder="placeholder"
          v-model="inputData"
          @input="uploadFile"
        >
        </b-form-file>
        <div
          class="
            newUploadDoc-innerContent
            d-flex
            align-items-center
            justify-content-center
            h-100
            w-100
            flex-column
          "
        >
          <div class="">
            <img
              src="../../assets/New-imgs/CustVend-icons/manage-upload-icon.svg"
              alt=""
            />
            <span class="newUploadDoc-innerContent-font-blk ml-2">
              Drag & Drop or
            </span>
            <span class="newUploadDoc-innerContent-font-blue">
              Browse file
            </span>
          </div>
          <div class="upload-failed-text" v-if="maxSize || invalidFile">
            <div class="mt-12px">
              <img
                src="../../assets/New-imgs/CustVend-icons/uploadfailed.svg"
                alt=""
                class="mr-2"
              />
              Upload Failed
            </div>
            <div
              class="newInt-required-validation-font"
              style="bottom: -20px; left: 0"
              v-if="invalidFile"
            >
              Invalid File Format
            </div>
            <div
              class="newInt-required-validation-font"
              style="bottom: -20px; left: 0"
              v-else-if="maxSize"
            >
              Max size exceeded
            </div>
          </div>
        </div>
      </div>
      <div v-else class="w-100">
        <div
          v-if="fileExtension !== 'pdf'"
          class="d-flex align-items-center align-replace-delete"
        >
          <div class="uploadImg-replace">
            <b-form-file
              :accept="acceptedFormat.join(',')"
              ref="uploadFiles"
              :id="id"
              :type="type"
              :placeholder="placeholder"
              v-model="inputData"
              @input="uploadFile"
            >
            </b-form-file>
            <img
              class="pointer align-replace"
              src="../../assets/New-imgs/CustVend-icons/manage-replace-icon.svg"
              alt=""
            />
          </div>
          <img src="../../assets/img/line.svg" class="mx-2" alt="" />
          <img
            class="pointer"
            @click.stop="removeFile()"
            src="../../assets/img/uploadImage-delete-icon.svg"
            alt=""
          />
        </div>
        <div
          class="h-100 w-100 p-3 relativeclass"
          :class="fileExtension !== 'pdf' && 'text-center'"
        >
          <div
            v-if="fileExtension === 'pdf'"
            class="
              relativeclass
              w-100
              d-flex
              align-items-center
              justify-content-between
            "
          >
            <div style="width: 75%" class="d-flex align-items-center">
              <img
                src="../../assets/New-imgs/CustVend-icons/pdf-uploaded.svg"
                alt=""
              />
              <div class="ml-2 w-100 text-truncate ct-table-bold-txt-4">
                {{ uploadedFileName }}
              </div>
            </div>
            <div class="d-flex align-items-center align-replace-delete">
              <div class="uploadImg-replace">
                <b-form-file
                  :accept="acceptedFormat.join(',')"
                  ref="uploadFiles"
                  :id="id"
                  :type="type"
                  :placeholder="placeholder"
                  v-model="inputData"
                  @input="uploadFile"
                >
                </b-form-file>
                <img
                  class="pointer align-replace"
                  src="../../assets/New-imgs/CustVend-icons/manage-replace-icon.svg"
                  alt=""
                />
              </div>
              <img src="../../assets/img/line.svg" class="mx-2" alt="" />
              <img
                class="pointer"
                @click.stop="removeFile()"
                src="../../assets/img/uploadImage-delete-icon.svg"
                alt=""
              />
            </div>
          </div>
          <img
            v-else
            :src="imageData"
            :alt="uploadedFileName"
            class="align-backend-img"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "UploadImage",
  props: {
    label: String,
    type: String,
    mandatory: Boolean,
    placeholder: String,
    id: String,
    maxFileSize: String,
    fileFormat: Array,
    showError: Boolean,
    mediaType: String,
  },
  data() {
    return {
      inputData: [],
      imageData: [],
      isFileUploaded: false,
      uploadedFileName: null,
      fileExtension: null,
      maxSize: false,
      invalidFile: false,
      acceptedFormat: this.fileFormat.map((obj) => "." + obj),
    };
  },

  mounted() {
    this.reattachDropListener();
  },
  beforeDestroy() {
    this.removeDropListener();
  },

  computed: {
    tooltipContent() {
      if (!this.isFileUploaded) {
        return `
        Upload ${
          this.mediaType == "media"
            ? "media"
            : this.mediaType == "resume"
            ? "resume"
            : "screenshot"
        }<br>
        (${this.fileFormat.join(", ")})
        max ${this.maxFileSize} MB
      `;
      } else {
        return "";
      }
    },
  },

  methods: {
    reattachDropListener() {
      const fileTag = this.$refs.uploadFiles.$el;
      fileTag.addEventListener("drop", this.handleDrop);
    },
    removeDropListener() {
      const fileTag = this.$refs.uploadFiles.$el;
      fileTag.removeEventListener("drop", this.handleDrop);
    },
    handleDrop(event) {
      event.preventDefault();
      const files = event.dataTransfer.files;

      if (files.length > 0) {
        const file = files[0];
        this.inputData = files[0];
        const fileName = file.name;
        const fileSize = file.size / (1024 * 1024);
        const allowedFormats = this.fileFormat.map((format) =>
          format.toLowerCase()
        );

        // Check file size
        if (fileSize > parseFloat(this.maxFileSize)) {
          this.resetFileState();
          this.maxSize = true;
          return;
        }

        // Check file format
        this.fileExtension = fileName.split(".").pop().toLowerCase();
        if (!allowedFormats.includes(this.fileExtension)) {
          this.resetFileState();
          this.invalidFile = true;
          return;
        }

        // Read the file as data URL
        const reader = new FileReader();
        reader.onload = (e) => {
          this.imageData = e.target.result;
          this.uploadedFileName = fileName;
          this.isFileUploaded = true;
          this.maxSize = false;
          this.showError = false;
          this.invalidFile = false;
          this.$emit("select-value", this.inputData);
        };
        reader.readAsDataURL(file);
      }
    },

    uploadFile(file) {
      const fileName = file.name;
      const fileSize = file.size / (1024 * 1024);
      const allowedFormats = this.fileFormat.map((format) =>
        format.toLowerCase()
      );

      // Check file size
      if (fileSize > parseFloat(this.maxFileSize)) {
        this.resetFileState();
        this.maxSize = true;
        return;
      }

      // Check file format
      this.fileExtension = fileName.split(".").pop().toLowerCase();
      if (!allowedFormats.includes(this.fileExtension)) {
        this.resetFileState();
        this.invalidFile = true;
        return;
      }

      // Read the file as data URL
      const reader = new FileReader();
      reader.onload = (e) => {
        this.imageData = e.target.result;
        this.uploadedFileName = fileName;
        this.isFileUploaded = true;
        this.maxSize = false;
        this.showError = false;
        this.invalidFile = false;
        this.$emit("select-value", this.inputData);
      };
      reader.readAsDataURL(file);
    },
    removeFile() {
      this.resetFileState();
    },
    resetFileState() {
      this.inputData = null;
      this.imageData = null;
      this.isFileUploaded = false;
      this.uploadedFileName = null;
      this.maxSize = false;
      this.invalidFile = false;
      this.fileExtension = null;
      if (this.id == "attachment") this.$emit("select-value", this.inputData);
      this.$nextTick(() => {
        this.reattachDropListener();
      });
    },
  },
};
</script>

<style scoped>
.upload-failed-text {
  color: #eb0002;
  font-family: "Lato", sans-serif;
  font-size: 16px;
  font-weight: 500;
}
.validationinputfile {
  background: #fff !important;
}

/* Add your custom styles here */

.align-replace-delete {
  position: absolute;
  top: 0;
  right: 0;
}

.align-replace {
  height: 100%;
  top: -1px;
  position: absolute;
  left: -1px;
}

.align-backend-img {
  max-width: 100%;
  max-height: 100%;
  border-radius: 10px;
}

.newUploadDoc {
  height: 101px;
}
.upload-pdf-file-name {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0px 4px 8px 0px #0000002b;
  position: relative;
}

.img-scroll {
  min-height: auto;
  max-height: 380px;
  overflow: auto;
}
</style>
